/**
 * Labstep
 */

import { ICONS } from 'labstep-web/constants/icons';
import type { ISubLinksProps } from './types';

export const subLinks: ISubLinksProps = {
  overview: {
    route: {
      to: 'group_show',
    },
    icon: ICONS.group.info.home,
    text: 'Overview',
  },
  experiments: {
    route: {
      to: 'group_experiment_workflows',
    },
    icon: ICONS.experiment_workflow.primary,
    text: 'Experiments',
  },
  protocols: {
    route: {
      to: 'group_protocol_collections',
    },
    icon: ICONS.protocol_collection.primary,
    text: 'Protocol Library',
  },
  inventory: {
    route: {
      to: 'group_resources',
    },
    routes: ['group_resources', 'group_resource_items'],
    icon: ICONS.resource.primary,
    text: 'Inventory',
    premiumFeature: 'inventory',
  },
  ordering: {
    route: {
      to: 'group_order_requests',
    },
    routes: ['group_order_requests', 'group_purchase_orders'],
    icon: ICONS.order_request.primary,
    text: 'Order Management',
    premiumFeature: 'order_management',
  },
  devices: {
    route: {
      to: 'group_devices',
    },
    icon: ICONS.device.primary,
    text: 'Instruments & Devices',
    premiumFeature: 'devices',
  },
  entity_views: {
    route: {
      to: 'group_entity_views',
    },
    icon: 'clipboard',
    text: 'Reporting',
    premiumFeature: 'reporting',
  },
  files: {
    route: {
      to: 'group_files',
    },
    icon: ICONS.file.primary,
    text: 'Uploaded Files',
    hide: false,
  },
  settings: {
    route: {
      to: 'group_settings',
    },
    routes: [
      'group_settings',
      'group_users',
      'group_settings_experiment_workflow',
      'group_settings_experiment_workflow_templates',
      'group_settings_experiment_entity_state_workflow',
      'group_settings_experiment_tags',
      'group_settings_protocol',
      'group_settings_protocol_tags',
      'group_settings_protocol_lock_settings',
      'group_settings_inventory_categories',
      'group_settings_inventory_locations',
      'group_settings_inventory_tags',
      'group_settings_device_categories',
      'group_settings_jupyter',
      'group_settings_device_tags',
      'group_settings_order_request_template',
      'group_settings_purchase_order_template',
      'group_settings_order_request_tags',
      'group_settings_export',
      'group_settings_auto_sharing',
      'group_settings_notifications',
    ],
    icon: 'cog',
    text: 'Workspace Settings',
  },
};

export const primaryLinks = Object.values(subLinks).filter(
  (link) => !link.hide,
);

export const extraLinks = [];
